import type { WidgetMessages } from './types.ts';

export const es: WidgetMessages = {
  panelTitle: 'Enviar comentarios',
  panelClose: 'Cerrar',
  fieldTitleLabel: 'Resumen breve',
  fieldTitlePlaceholder: 'Descripción breve',
  fieldSummaryLabel: 'Detalles',
  fieldSummaryPlaceholder: 'Pasos para reproducirlo, qué esperabas, qué ocurrió en realidad…',
  fieldNameLabel: 'Tu nombre',
  fieldEmailLabel: 'Tu correo electrónico',
  fieldSaveContactLabel: 'Guardar tu nombre y correo electrónico',
  fieldSaveContactUnavailable:
    'Tu navegador está bloqueando el almacenamiento, así que esto no se puede guardar.',
  fieldNotifyOnFixLabel: 'Avisarme por correo cuando esté corregido',
  buttonSend: 'Enviar informe',
  buttonSending: 'Enviando…',
  buttonWaitingForUploads: 'Esperando los archivos adjuntos…',
  errorTitleRequired: 'Añade un resumen breve.',
  successHeading: 'Gracias, hemos recibido tu informe.',
  successCopy: (ref) => `Código de referencia: ${ref}`,
  successPartialNotice: (failed, total) =>
    failed === total
      ? failed === 1
        ? 'No hemos podido procesar tu adjunto, así que no se ha incluido en el informe.'
        : `No hemos podido procesar los ${total} adjuntos, así que no se han incluido en el informe.`
      : `No hemos podido procesar ${failed} de ${total} adjuntos, así que no se han incluido en el informe.`,
  successAnotherButton: 'Enviar otro informe',
  poweredBy: 'Con tecnología de OnCatch',

  recordingConsentTitle: 'Graba tu pantalla',
  recordingConsentLead: (ws) =>
    `Vas a compartir tu pantalla con el equipo de soporte de ${ws} para mostrar un error.`,
  recordingConsentBulletAdminsOnly:
    'La grabación se envía solo a los administradores de tu espacio de trabajo.',
  recordingConsentBulletMicAudio:
    'Se captura el audio del micrófono si tu navegador lo permite; verás una solicitud de permiso.',
  recordingConsentBulletMaxLength:
    'La duración máxima es de 5 minutos — la grabación se detiene automáticamente al llegar al límite.',
  recordingConsentBulletRetention: (d) =>
    `Se conserva durante ${d} días y luego se elimina automáticamente.`,
  recordingConsentBulletDeletion:
    'Puedes solicitar la eliminación antes desde la configuración de tu cuenta.',
  recordingConsentCancelBtn: 'Cancelar',
  recordingConsentAcceptBtn: 'Acepto, iniciar grabación',
  recordingChoiceTitle: 'Elige una grabación',
  recordingChoiceLead:
    'Elige lo que quieres capturar. Revisarás lo que se comparte antes de que empiece la grabación.',
  recordingChoiceScreen: 'Grabación de pantalla',
  recordingChoiceScreenDetail: 'Graba tu pantalla y, opcionalmente, el audio del micrófono.',
  recordingChoiceCamera: 'Grabación de pantalla con cámara',
  recordingChoiceCameraDetail: 'Graba tu pantalla con una superposición de cámara.',
  recordingChoiceAudio: 'Grabación de audio',
  recordingChoiceAudioDetail: 'Graba solo el audio del micrófono.',
  recordingChoiceUnavailable: 'No disponible en este navegador',
  recordingAudioConsentTitle: 'Grabar audio',
  recordingAudioConsentLead: (ws) =>
    `El audio de tu micrófono se compartirá con el equipo de soporte de ${ws} para ayudar a explicar este problema.`,
  recordingAudioConsentTip:
    'Tu navegador pedirá acceso al micrófono. Elige el micrófono que quieres usar y permite el acceso.',

  recordingTimerIdle: 'Grabando 0:00',
  recordingTimer: (m, s) => `Grabando ${m}:${String(s).padStart(2, '0')}`,
  recordingStopBtn: 'Detener',
  recordingStartedAnnouncement: 'Grabación iniciada',
  recordingProgressAnnouncement: (sec) => `Grabando ${sec} segundos`,

  captureRegionHelp: 'Haz clic y arrastra para seleccionar una región · Pulsa Esc para cancelar',
  captureLabelCapturing: 'Capturando…',
  captureLabelPreparing: 'Preparando…',
  captureRegionCapturing: 'Capturando región…',

  safariUnsupportedTitle: 'La grabación de pantalla no es compatible con este navegador',
  safariUnsupportedBody:
    'La grabación de pantalla requiere Chrome, Edge o Firefox de escritorio. Aún puedes adjuntar capturas y enviar tu informe.',

  attachmentsLabel: 'Adjuntos',
  captureWholePageBtn: 'Página completa',
  captureSelectRegionBtn: 'Seleccionar área',
  captureSelectElementBtn: 'Seleccionar elemento',
  captureRecordBtn: 'Grabar',
  cameraDeniedFallback: 'Acceso a la cámara denegado — grabando solo la pantalla.',
  recordingConsentBulletCamera:
    'Tu cámara aparecerá en la esquina de la grabación. Rechaza la solicitud de cámara para grabar solo la pantalla.',
  recordingConsentIncludeCameraLabel: 'Incluir cámara',
  recordingUnsupportedInline:
    'La grabación de pantalla no es compatible con este navegador. Las capturas siguen funcionando.',

  // ── Upload dropzone (#605) ───────────────────────────────────────────
  uploadDropzoneBtn: 'Subir archivo',
  uploadDropzoneHint: () => 'PNG, JPEG, WebP · PDF, Word (.docx)',
  uploadDropzoneCapReached: 'Límite de adjuntos alcanzado — elimina uno para subir.',
  uploadErrorUnsupportedType: 'Solo se pueden subir archivos PNG, JPEG, WebP, PDF o DOCX.',
  uploadErrorFileTooLarge: 'Archivo demasiado grande (máx. 50 MB).',
  uploadErrorGeneric: 'Error al subir. Inténtalo de nuevo.',
  uploadErrorTooMany: (skipped) =>
    skipped === 1
      ? '1 archivo omitido — límite de adjuntos alcanzado.'
      : `${skipped} archivos omitidos — límite de adjuntos alcanzado.`,

  storageFullNotice: 'Archivos adjuntos no disponibles',
  storageFullDetailedNotice:
    'Archivos adjuntos no disponibles — almacenamiento del espacio de trabajo lleno',

  challengeIntro: 'Verificación rápida para confirmar que eres humano.',
  challengeFailed: 'Verificación fallida. Inténtalo de nuevo.',

  annotateTitle: 'Anotar captura',
  toolArrow: 'Flecha',
  toolBox: 'Caja',
  toolPen: 'Dibujar',
  toolText: 'Texto',
  colorRed: 'Rojo',
  colorYellow: 'Amarillo',
  colorGreen: 'Verde',
  colorBlack: 'Negro',
  buttonUndo: 'Deshacer',
  buttonClear: 'Borrar',
  buttonSkip: 'Omitir',
  buttonSave: 'Guardar',
  textInputPlaceholder: 'Escribe etiqueta, pulsa Enter',
  saveError: 'No se pudo guardar la anotación. Usando captura sin editar.',
  activeIndicator: 'activo',
};
